import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { addDefaultSrc, getDefaultSrc } from '../news-helpers';
import SafeHtml from '../../../../components/SafeHtml';

export default function MostRead({ newsDetails }) {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const pid = searchParams.get('pid');
  const investor = searchParams.get('investor');

  const getLinkTo = () => {
    if (pid) {
      return `${location.pathname}?pid=${pid}&newsID=${newsDetails.newsid}`;
    } else if (investor) {
      return `${location.pathname}?investor=${investor}&newsID=${newsDetails.newsid}`;
    } else {
      return `${location.pathname}?newsID=${newsDetails.newsid}`;
    }
  };

  return (
    <div className="row fadeInAnimation mostVisitBlock">
      <div className="row d-flex justify-content-center imageHeader">
        <img onError={addDefaultSrc} src={getDefaultSrc(newsDetails)} alt="newslogo" />
      </div>

      <div className="row titleBlock">
        <p className="titleBlockModule">{newsDetails?.module}</p>
        <p className="titleBlockTitle">
          <SafeHtml html={newsDetails?.headLine} tag="b" />
        </p>
        <p className="titleBlockDate">{newsDetails?.newsDate}</p>
      </div>
      <SafeHtml html={newsDetails?.shortArticle} tag="p" className="row mostReadShortArticle ps-4" />
      <p className="row">
        <div className="col-12 col-md-12 cursor-pointer read-more-padding">
          <Link to={getLinkTo()} activeclassname="active" className="mostReadLink">
            <b>Read more</b>
          </Link>
        </div>
      </p>
    </div>
  );
}
